import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { McpServerScreen } from "./McpServerScreen";

// Live's `/app/mcp-server`, under the team: the tokens it makes are the team's.
export const mcpServerRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "mcp-server",
  component: McpServerScreen,
});
